
/*********************** single product map (product details block) **************************/
import * as marker from '../../../../../wd-main-plugin/images/marker.svg'
document.addEventListener('DOMContentLoaded', init )
function init () {
  const maps = document.querySelectorAll('.map-line')
  if ( maps.length ) {
    maps.forEach( mapDOM => {
      const api = mapDOM.querySelector('#locationInfo').dataset.mapApi
      const singleProductLocationInfo = JSON.parse( mapDOM.querySelector('#locationInfo').value )
      const singleProductZoomLevel = parseInt( mapDOM.querySelector('#zoomLevel').value )
      if( api == 'google') {
        const geocoder = new google.maps.Geocoder()
        const infowindow = new google.maps.InfoWindow()
        const areas = JSON.parse( mapDOM.querySelector('#locationInfo').dataset.areas )
        let styles
    
        fetch( `${devia.home_url}/wp-content/plugins/wd-main-plugin/includes/map-styles/map-style.json` )
        .then(response => {
          return response.json()
        })
        .then( defaultStyle => styles = defaultStyle )
      
        try {
          const styleString = mapDOM.querySelector( '#locationInfo').dataset.mapStyle
          if ( styleString != '' )
            styles = JSON.parse( mapDOM.querySelector( '#locationInfo').dataset.mapStyle )
          else alert( 'Empty custom map style, please enter a valid custom JSON value or choose from the available.' )
        } catch(e){
          alert( 'Invalid custom map style JSON, the fallback style will be shown instead!' )
        }
      
        const styledMap = new google.maps.StyledMapType(styles, {
          name: "Styled Map"
        })
    
        const map = new google.maps.Map(mapDOM.querySelector('#map'), {
          center: singleProductLocationInfo,
          zoom: singleProductZoomLevel,
          mapTypeControl: false
        })
    
        map.mapTypes.set('map_style', styledMap)
        map.setMapTypeId('map_style')
    
        geocodeLatLng(geocoder, map, infowindow, singleProductLocationInfo, areas)
      } else {
        // Create the map
        const map = new OpenLayers.Map("map")
    
        // Create a base layer (e.g., OpenStreetMap)
        const baseLayer = new OpenLayers.Layer.OSM("OpenStreetMap")
        map.addLayer(baseLayer)
    
        let markerStyle = {
          // Use a custom PNG image for the marker
          externalGraphic: marker.default,
          graphicWidth: 32,   // Width of the custom marker image
          graphicHeight: 32,  // Height of the custom marker image
          graphicXOffset: -16, // X offset to center the custom marker image
          graphicYOffset: -32, // Y offset to align the bottom of the image with the 
        };
        // Create a vector layer for the markers with the custom style
        let markersLayer = new OpenLayers.Layer.Vector("Markers Layer", {
          styleMap: new OpenLayers.StyleMap(markerStyle)
        })
    
        map.addLayer(markersLayer)
        
        let lonLat = new OpenLayers.LonLat(singleProductLocationInfo.lng, singleProductLocationInfo.lat).transform(
          new OpenLayers.Projection("EPSG:4326"),   // Source projection (e.g., WGS84)
          map.getProjectionObject()                  // Target projection of the map
        )
        
        let point = new OpenLayers.Geometry.Point(lonLat.lon, lonLat.lat)
        let markerFeature = new OpenLayers.Feature.Vector(point)
        
        markersLayer.addFeatures(markerFeature)
        
        map.setCenter(lonLat)
        // Fit the map extent to the markers
        map.zoomTo(singleProductZoomLevel)
      }
    } )

  }
}
